var React = require('react');

function IconEmail (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"m1.3477 18.855 44.445 31.988c2.3555 2.0195 5.7227 2.0195 8.418 0l44.109-31.988c-0.67187-0.67188-1.3477-1.0117-2.3555-1.0117h-91.918c-1.0117 0-2.0195 0.33594-2.6953 1.0117z","key":0}),React.createElement("path",{"d":"m0 72.727 29.965-25.59-29.965-21.883z","key":1}),React.createElement("path",{"d":"m69.695 47.137 30.305 25.59v-47.473z","key":2}),React.createElement("path",{"d":"m99.328 80.133-34.344-29.629-7.0703 5.3867c-4.7148 3.3672-11.109 3.3672-15.824 0l-7.0703-5.3867-34.344 29.629c0.67188 1.0117 1.6836 2.0195 3.3672 2.0195h91.918c1.3477 0 2.6953-1.0117 3.3672-2.0195z","key":3})]));
}

IconEmail.defaultProps = {"width":"100pt","height":"100pt","version":"1.1","viewBox":"0 0 100 100"};

module.exports = IconEmail;

IconEmail.default = IconEmail;
